var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"merchant-list"},[_c('GlobalInfoBar',{attrs:{"title":"商家列表","content":"管理人员可在后台添加回收商家、查看商家详细资料及禁用/启用商家等，申请入驻审核通过的商家将自动进入"}}),_c('GlobalChunk',{attrs:{"icon":"search","title":"筛选查询"}},[_c('div',{attrs:{"slot":"filter"},slot:"filter"},[_c('Form')],1),_c('Table')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }